import { h } from 'preact'
import { PureComponent } from 'preact/compat'
import styles from './heading.module.css'

import { BylineType } from './domain'

type HeadingProps = {
  tittel: string
  ingress: string
  byline: BylineType
}

export class Heading extends PureComponent<HeadingProps> {
  render() {
    return (
      <div className={styles.headingWrapper}>
        <a className={styles.headinglogo} href="http://www.nrk.no/" title="Forsiden av NRK.no">
          <svg width="3.5em" height="1.4em" aria-hidden="true">
            <use xlinkHref="#nrk-logo-nrk" />
          </svg>
        </a>
        <div className={styles.heading}>
          <h1 className={styles.scribble}>
            Norske ungdommer forteller:
            <br />
            <strong>
              – Sperret inne, <br />
              slått og lenket&nbsp;fast
            </strong>
          </h1>
          <p className={styles.introtext}>{this.props.ingress}</p>
          <p
            className={styles.byline}
            dangerouslySetInnerHTML={{ __html: this.props.byline.tekst }}
          />
          <p
            className={styles.byline}
            dangerouslySetInnerHTML={{ __html: this.props.byline.grafikk }}
          />
          {/*
          <span className={styles.intro_block_arrow} aria-hidden>
            <span>Les historien</span>
            <div>
              <svg aria-hidden='true' width='30' height='30'>
                <use xlinkHref='#nrk-chevron-down'/>
              </svg>
            </div>
          </span>
          */}
        </div>
      </div>
    )
  }
}
